import { createAction } from "@reduxjs/toolkit";
import {
    STORE_CURB_LINKS,
    STORE_IS_IFRAME_VIEW,
    STORE_CURB_REGULATIONS,
    SET_IS_GEOSERVER_ENABLED,
    STORE_DICTIONARY_CURB_LINKS_AND_REGULATIONS,
    StoreCurbLinksAction,
    StoreIsIframeViewAction,
    StoreCurbRegulationsAction,
    SetIsGeoserverEnabledAction,
    StoreCurbLinksAndRegulationsAction,
    CurrentApplicationVersionAction,
    CURRENT_APPLICATION_VERSION,
    STORE_GEOSERVER_CURB_REGULATIONS,
    StoreGeoserverCurbRegulationsAction
} from "./types";

export const storeCurbLinks = createAction<StoreCurbLinksAction["payload"]>(STORE_CURB_LINKS);

export const storeIsIframeView =
    createAction<StoreIsIframeViewAction["payload"]>(STORE_IS_IFRAME_VIEW);

export const storeCurbRegulations =
    createAction<StoreCurbRegulationsAction["payload"]>(STORE_CURB_REGULATIONS);

export const setIsGeoserverEnabled =
    createAction<SetIsGeoserverEnabledAction["payload"]>(SET_IS_GEOSERVER_ENABLED);

export const storeDictionaryCurbLinksAndRegulations = createAction<
    StoreCurbLinksAndRegulationsAction["payload"]
>(STORE_DICTIONARY_CURB_LINKS_AND_REGULATIONS);

export const currentApplicationVersion = createAction<CurrentApplicationVersionAction["payload"]>(
    CURRENT_APPLICATION_VERSION
);

export const storeGeoserverCurbRegulations = createAction<
    StoreGeoserverCurbRegulationsAction["payload"]
>(STORE_GEOSERVER_CURB_REGULATIONS);
